import { Box } from '@mui/material'
import { FC } from 'react'
import Carousel from 'react-material-ui-carousel'

import { InspectionMediaEntry, RepairOrderMediaEntry } from '../../sdk'
import { convert1DArrayTo2D } from '../../utils/convert1DArrayTo2D/convert1DArrayTo2D'
import { AddMediaButtonCached } from './AddMediaButtonCached'
import { CachedImageBox } from './CachedImageBox'
import { CarouselSlides, DummyImageBoxUI } from './MediaGallaryUI'

export enum MediaEntryType {
  inspectionPrompt,
  repairOrder
}

interface Props {
  media: InspectionMediaEntry[]
  parentId: string
  isMobileDevice: boolean
  inspectionId: string
}

const dummyMediaEntry: InspectionMediaEntry | RepairOrderMediaEntry = {
  id: 'dummy'
}

export const MediaGalleryCached: FC<Props> = ({
  media,
  parentId,
  isMobileDevice,
  inspectionId
}) => {
  return (
    <Box sx={{ width: '100%' }}>
      <Carousel autoPlay={false} navButtonsAlwaysVisible height="300px">
        {[...convert1DArrayTo2D([dummyMediaEntry, ...media], 2)].map(
          (group, index) => (
            <CarouselSlides key={index}>
              {group.map((entry) =>
                entry.id === 'dummy' ? (
                  <DummyImageBoxUI
                    isMobileDevice={isMobileDevice}
                    key={entry.id!}>
                    <AddMediaButtonCached
                      parentId={parentId}
                      isMobileDevice={isMobileDevice}
                      inspectionId={inspectionId}
                      curIndex={media.length}
                    />
                  </DummyImageBoxUI>
                ) : (
                  <CachedImageBox
                    entry={entry}
                    key={entry.id!}
                    parentId={parentId}
                    inspectionId={inspectionId}
                  />
                )
              )}
            </CarouselSlides>
          )
        )}
      </Carousel>
    </Box>
  )
}
